import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          if (process.env.NODE_ENV === 'development') {
            console.error('No session_id found in URL');
          }
          navigate('/login');
          return;
        }

        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/customer/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        if (response.data.success) {
          // Navigate to home with user data
          navigate('/', { 
            replace: true,
            state: { user: response.data.user }
          });
        } else {
          throw new Error('Authentication failed');
        }
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Auth callback error:', error);
        }
        alert('Login failed. Please try again.');
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-orange-500 mx-auto mb-4"></div>
        <p className="text-gray-600 text-lg">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
